import { useEffect } from "react";

const API_URL = "https://srinivasafleet.com/api";


export function useSessionWatcher() {
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const source = new EventSource(`${API_URL}/auth/session-events?token=${token}`);

    source.addEventListener("session", (e) => {
      const data = JSON.parse(e.data);
      if (data.status === "evicted") {
        source.close();
        localStorage.clear();
        window.location.href = "/login?reason=session_revoked";
      }
    });

    source.onerror = () => {
    };

    return () => source.close();
  }, []);
}